import { ReactNode } from "react";
import { Box } from "@mui/material";
import { CSSProperties } from "@mui/styles";

type Props = {
  children: ReactNode;
  styleProps?: CSSProperties;
  notColumnOnMobile?: boolean;
};
export const FlexBoxRow = ({
  children,
  styleProps,
  notColumnOnMobile,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: notColumnOnMobile ? "row" : ["column", "row"],
        gap: [2, 3, 3, 3],
        ...styleProps,
      }}
    >
      {children}
    </Box>
  );
};
